import type { PermissionKey, PlanFeature } from './generated/Api';

/**
 * What every page, tab and menu item in both apps states about who may open
 * it: the Roles page checkboxes that show it and the plan feature it needs.
 * Both are required in each app's tables, so a page added without saying
 * either does not compile, and docs/generated/screens.md is written from
 * them.
 *
 * Leaving one out used to mean "everyone" and "every plan", which a reader
 * could not tell from a gate forgotten: the dashboard showed Trucks, Team
 * Members and Roles to every role while the mobile app asked for a key.
 */

/** Shown to every member, on purpose. Say why beside each use. */
export const EVERYONE = 'everyone';

/** On every plan, on purpose. */
export const EVERY_PLAN = 'every plan';

/** Any one of these keys shows it, or `EVERYONE`. */
export type PagePermissions = readonly PermissionKey[] | typeof EVERYONE;

/** The plan feature it needs, or `EVERY_PLAN`. */
export type PagePlan = PlanFeature | typeof EVERY_PLAN;

/** Whether a member holding `can` passes `permissions`. */
export const holdsAnyOf = (
  permissions: PagePermissions,
  can: (key: PermissionKey) => boolean
): boolean => permissions === EVERYONE || permissions.some(can);
